import { GOOGLE_STORAGE } from '../config/identityProviders';
import { userApi } from './api';

export function currentGoogleRedirectUri(): string {
  return `${window.location.origin}/auth/google/callback`;
}

export async function startGoogleLogin(): Promise<void> {
  const { data } = await userApi.getGoogleConfig();
  if (!data.enabled || !data.clientId) {
    throw new Error('Google sign-in is not configured. Add a Google OAuth ClientId and ClientSecret to Authorization settings.');
  }

  const redirectUri = currentGoogleRedirectUri();
  const state = crypto.randomUUID();
  sessionStorage.setItem(GOOGLE_STORAGE.state, state);
  sessionStorage.setItem(GOOGLE_STORAGE.redirectUri, redirectUri);

  const params = new URLSearchParams({
    response_type: 'code',
    client_id: data.clientId,
    redirect_uri: redirectUri,
    scope: 'openid email profile',
    state,
    access_type: 'online',
    prompt: 'select_account',
  });

  window.location.assign(`https://accounts.google.com/o/oauth2/v2/auth?${params.toString()}`);
}

export function consumeGoogleOAuthState(): string | null {
  const state = sessionStorage.getItem(GOOGLE_STORAGE.state);
  sessionStorage.removeItem(GOOGLE_STORAGE.state);
  return state;
}

export function consumeGoogleRedirectUri(): string {
  const stored = sessionStorage.getItem(GOOGLE_STORAGE.redirectUri);
  sessionStorage.removeItem(GOOGLE_STORAGE.redirectUri);
  return stored || currentGoogleRedirectUri();
}
